import {CourseDto} from "../../modules/Courses/models/Course.dto";
import {CourseKind} from "../../modules/Courses/models/Course.model";


const translateCourseKind: Record<CourseKind, string | null> = {
    'regular': "Regular",
    'mini': "Complementar",
    'regional': "Regionais"
};

/**
 * Obtém as tags de um curso.
 * @param course - O objeto do curso.
 * @returns Array de tags do curso.
 */
export default function getCourseTags(course: CourseDto ): string[] {
    try {
        const tags: string[] = [];
        const type: string | null = translateCourseKind[course.kind];
        const isRegular = course.kind === "regular"

        if (type) {
            tags.push(type);
        }

        if(isRegular) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const averageDuration: string | undefined = course.programs?.[0]?.averageDuration;

        if (averageDuration) {
            const textAvDuration = averageDuration + " semanais";
            tags.push(textAvDuration);
        }


        if (averageDuration) {
            const textAvDuration = averageDuration + " semanais"
            tags.push(textAvDuration);
        }

        const monthsDuration = calculateCourseDurationInMonths(course)

        if (monthsDuration) {
            const monthsStr = monthsDuration === 1 ? monthsDuration + " mês" : monthsDuration + " meses";
            tags.push(monthsStr);
        }
        }

        return tags;
    } catch (e) {
        return [];
    }
}

/**
 * Calcula a duração total do curso em meses.
 * @param course - O objeto do curso.
 * @returns Duração total do curso em meses.
 */
export function calculateCourseDurationInMonths(course: CourseDto): number {
    if (!course.startDate || !course.endDate) {
        return 0;
    }

    const startDate = new Date(course.startDate);
    const endDate = new Date(course.endDate);

    let months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
    months -= startDate.getMonth();
    months += endDate.getMonth();

    return Math.max(0, months);
}
